// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HybridEnrollmentRequestModel {
    static getAttributeTypeMap() {
        return HybridEnrollmentRequestModel.attributeTypeMap;
    }
}
HybridEnrollmentRequestModel.discriminator = undefined;
HybridEnrollmentRequestModel.additionalProperties = false;
HybridEnrollmentRequestModel.attributeTypeMap = [
    {
        "name": "cardInfo",
        "baseName": "cardInfo",
        "type": "EnrollmentCardInfoModel"
    },
    {
        "name": "insuranceVerification",
        "baseName": "insuranceVerification",
        "type": "EnrollmentMedBenInsuranceVerificationModel"
    },
    {
        "name": "survey",
        "baseName": "survey",
        "type": "Array<EnrollmentSurveyQuestionModel>"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentMedBenClientIdentifiersModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "MedBenEnrollmentDemographicsModel"
    },
    {
        "name": "guardianInfo",
        "baseName": "guardianInfo",
        "type": "EnrollmentGuardianInfoModel"
    },
];
//# sourceMappingURL=hybridEnrollmentRequestModel.js.map